import { createClient } from "@sanity/client";
import { getLatestSanityApiVersion } from "./sanity/client";
import imageUrlBuilder from "@sanity/image-url";

// sanity client for frontend SPA
export const sanityClient = createClient({
  projectId: "cb2fptrj",
  dataset: import.meta.env.VITE_SANITY_DATASET || "production",
  apiVersion: getLatestSanityApiVersion(),
  useCdn: true, // Use CDN for perf
});

const builder = imageUrlBuilder(sanityClient);
export const urlForImage = (source?: any) => {
  if (!source) return "";
  return builder.image(source).url();
};

// // helper to build image URLs from sanity data references
// export function urlForImage(source: any) {
//   if (!source?.asset?._ref) return "";

//   const projectId = "cb2fptrj";
//   const dataset = import.meta.env.VITE_SANITY_DATASET || "production";

//   // extract image ID from reference
//   // format: image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg
//   const [, id, dimensions, format] = source.asset._ref.split("-");

//   return `https://cdn.sanity.io/images/${projectId}/${dataset}/${id}-${dimensions}.${format}`;
// }
